import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'

import { AuthContext } from '../../providers'
import { useGetRepairOrdersQuery } from '../../redux/api'
import { loggingAssert } from '../../utils/handleError/loggingAssert'
import { RepairOrderTabs } from '../SharedUI'

export const RepairOrderByVehicle = () => {
  const { id: vehicleId } = useParams()
  const { currentUser, userShopId } = useContext(AuthContext)
  const { data: repairOrders } = useGetRepairOrdersQuery(
    {
      authorization: loggingAssert('Token not set', currentUser!.accessToken),
      shop: loggingAssert('ShopId not set', userShopId),
      vehicle: vehicleId!
    },
    { skip: !vehicleId }
  )

  return (
    <>
      {repairOrders && (
        <RepairOrderTabs
          repairOrders={repairOrders}
          colsForEstimate={['created', 'localId', 'total']}
          colsForRepairOrder={[
            'created',
            'closedOn',
            'localId',
            'total',
            'status'
          ]}
        />
      )}
    </>
  )
}
